const binding = { modules: {}, dataActions: {} };

    (binding.modules['mfrm-content-reel'] = {
        c: () => require('partner/modules/mfrm-content-reel/mfrm-content-reel.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'mfrm-content-reel',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mfrm-content-reel'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|mfrm-content-reel|mfrm-content-reel'] = {
                c: () => require('partner/modules/mfrm-content-reel/mfrm-content-reel.view.tsx'),
                cn: '__local__-__local__-mfrm-content-reel'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };